<!-- <p>job-advertisement works!</p> -->
<!-- <p>annual-reports works!</p> -->
<div class="clear"></div>
<section class="banner">
	<div class="container py-4 d-flex justify-content-between align-items-center">
		<h1 class="mb-0">Job Advertisements</h1>
		<div class="input-group" style="max-width:300px;">
			<!-- <input type="text" class="form-control" [(ngModel)]="searchTerm" id="search" placeholder="search..."> -->
			<div class="input-group-append" id="button-addon4">
				<!-- <button class="btn btn-outline-secondary" type="button" (click)="ClearSearch()"><em class="fas fa-backspace fa-fw"></em></button> -->
			</div>
		</div>
	</div>
</section>
<div class="clear py-3"></div>
<section class="container">

  <h6 class="well font-weight-medium" *ngFor="let record of Records">
    <a (click)="getAttachmentByGUID(record.AttachmentFilePDF)" target="_blank" class="d-flex w-100 justify-content-between">
        <span>
            <i class="far fa-hand-point-right text-primary mr-2"></i>
            <ngx-highlight-words
              [textToHighlight]="formatJobText(record)"
              highlightClassName="bg-Searchable">
            </ngx-highlight-words>
        </span>
    </a>
  </h6>


</section>
